import styled from 'styled-components';
import { TextField as MuiTextField } from '@mui/material';

export const Root = styled.div`
  height: 100vh;
  color: black;
  overflow: auto;
`;

export const SettingsWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  max-width: 500px;
  margin: 0 auto;
`;

export const TextField = styled(MuiTextField)``;
